import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const token = localStorage.getItem('authToken');
 
  return (isAuthenticated || token) ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
